/*
  Weekend Sock Gift — temporary free-gift-with-purchase promo.

  Behaviour:
   - When the cart's non-gift merchandise subtotal reaches the threshold and the
     promo window is open, a popup invites the shopper to pick one free pair of
     socks (colour choice, availability aware).
   - The chosen variant is added with a `_free_gift` line property, quantity 1.
   - The actual price is zeroed by a native Shopify "Buy X Get Y" automatic
     discount (spend $50, get 1 from the Socks collection free). This script
     verifies the gift line really came through at $0 and pulls it back out if
     the discount did not apply, so a shopper is never charged for it.
   - If the qualifying subtotal drops back below the threshold, the gift is
     removed automatically. Quantity is locked to 1.
   - After the cutoff timestamp the script only cleans up stray gift lines.

  Self-contained. See weekend-sock-gift.css header for removal steps.
*/
(function () {
  var dataEl = document.getElementById('weekend-sock-gift-data');
  if (!dataEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!CONFIG || !Array.isArray(CONFIG.products)) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_PROP = '_free_gift';
  var SESSION_KEY = 'wsg_dismissed';

  var COLOR_HEX = {
    pink: '#f4a6c0', purple: '#7c5cbf', yellow: '#f2c94c', green: '#3f7d58',
    black: '#1f1f1f', white: '#f2f2f2', blue: '#3b6fb0', red: '#c0392b',
    grey: '#9aa0a6', gray: '#9aa0a6', navy: '#26324f', beige: '#d9c9a8',
    cream: '#f3ead7', orange: '#e07b39', brown: '#7a5230'
  };

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, CONFIG.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isGiftItem(item) {
    var p = item && item.properties;
    return !!p && (p[GIFT_PROP] === 'true' || p[GIFT_PROP] === true);
  }

  function nowSeconds() { return Math.floor(Date.now() / 1000); }
  function windowOpen() { return CONFIG.active === true && nowSeconds() < CONFIG.cutoff; }

  function getSessionDismissed() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function setSessionDismissed(v) {
    try {
      if (v) sessionStorage.setItem(SESSION_KEY, '1');
      else sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartMutationUrl(path) {
    return ROOT + 'cart/' + path;
  }

  function refreshThemeCartUI() {
    return fetchCart().then(function (cart) {
      // pubsub.js / constants.js expose these as classic-script globals (not on window).
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'weekend-sock-gift', cartData: cart });
      }
      // Cart bubble is its own section and not always refreshed by the pub/sub subscribers.
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        fetch(ROOT + '?section_id=cart-icon-bubble')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.shopify-section') || doc.body;
            if (inner && inner.innerHTML.trim()) bubble.innerHTML = inner.innerHTML;
          })
          .catch(function () {});
      }
      return cart;
    });
  }

  if (!customElements.get('weekend-sock-gift')) {
    customElements.define('weekend-sock-gift', class WeekendSockGift extends HTMLElement {
      constructor() {
        super();
        this.busy = false;
        this.selectedVariantId = null;
        this.openedBy = null;
        this.overlay = this.querySelector('[data-wsg-overlay]');
        this.dialog = this.querySelector('[data-wsg-dialog]');
        this.productsWrap = this.querySelector('[data-wsg-products]');
        this.cta = this.querySelector('[data-wsg-add]');
        this.pickerView = this.querySelector('[data-wsg-picker]');
        this.stateView = this.querySelector('[data-wsg-state]');
        this.productTpl = this.querySelector('[data-wsg-product-template]');
        this.swatchTpl = this.querySelector('[data-wsg-swatch-template]');

        this.onEval = this.debounce(this.evaluate.bind(this), 300);

        if (this.overlay) this.overlay.addEventListener('click', function () { this.hide(true); }.bind(this));
        this.querySelectorAll('[data-wsg-close]').forEach(function (btn) {
          btn.addEventListener('click', function () { this.hide(true); }.bind(this));
        }.bind(this));
        this.addEventListener('keyup', function (e) { if (e.code === 'Escape') this.hide(true); }.bind(this));
        if (this.cta) this.cta.addEventListener('click', this.onAdd.bind(this));
      }

      connectedCallback() {
        this.buildPicker();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.source === 'weekend-sock-gift') { this.decorateGiftLines(); return; }
            this.onEval();
          }.bind(this));
        }

        this.wrapFetch();
        window.addEventListener('pageshow', this.onEval);

        // Keep the gift line decoration in place as the cart drawer re-renders.
        var drawer = document.querySelector('cart-drawer');
        if (drawer && window.MutationObserver) {
          new MutationObserver(this.debounce(this.decorateGiftLines.bind(this), 150))
            .observe(drawer, { childList: true, subtree: true });
        }

        this.evaluate();
      }

      debounce(fn, wait) {
        var t;
        return function () {
          var args = arguments, ctx = this;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(ctx, args); }, wait);
        };
      }

      wrapFetch() {
        if (window.__wsgFetchWrapped) return;
        window.__wsgFetchWrapped = true;
        var native = window.fetch;
        var self = this;
        window.fetch = function () {
          var url = arguments[0];
          var str = typeof url === 'string' ? url : (url && url.url) || '';
          var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(str);
          var p = native.apply(this, arguments);
          if (isCartMutation && !self.busy) {
            p.then(function () { self.onEval(); }).catch(function () {});
          }
          return p;
        };
      }

      /* ---------- core decision loop ---------- */

      evaluate() {
        if (this.busy) return;
        var self = this;
        fetchCart().then(function (cart) {
          var giftLines = (cart.items || []).filter(isGiftItem);

          // After the cutoff (or feature inactive): remove any stray gift lines, nothing else.
          if (!windowOpen()) {
            if (giftLines.length) {
              self.removeLines(giftLines).then(function () { self.hide(false); });
            } else {
              self.hide(false);
            }
            return;
          }

          // Never keep more than one gift line.
          if (giftLines.length > 1) {
            self.removeLines(giftLines.slice(1)).then(function () { self.evaluate(); });
            return;
          }

          var gift = giftLines[0];
          var qualifyingPresentment = (cart.items || []).reduce(function (sum, item) {
            return isGiftItem(item) ? sum : sum + item.final_line_price;
          }, 0);
          // The threshold is $50 in the SHOP currency (USD). Cart amounts are in
          // the shopper's presentment currency, so divide back by the FX rate so
          // "$50" stays $50 regardless of the currency on display.
          var fxRate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
          if (!fxRate || fxRate <= 0) fxRate = 1;
          var qualifying = Math.round(qualifyingPresentment / fxRate);

          if (gift) {
            if (qualifying < CONFIG.thresholdCents) {
              self.removeLines([gift]).then(function () { setSessionDismissed(false); });
              return;
            }
            if (gift.final_line_price > 0) {
              // The automatic discount did not apply — do not let the shopper pay for it.
              self.removeLines([gift]).then(function () {
                setSessionDismissed(true);
                self.showState(CONFIG.strings.unavailable, true);
              });
              return;
            }
            if (gift.quantity !== 1) {
              self.busy = true;
              fetch(cartMutationUrl('change.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: gift.key, quantity: 1 })
              }).then(function () { return refreshThemeCartUI(); })
                .catch(function () {})
                .then(function () { self.busy = false; });
            }
            self.hide(false);
            self.decorateGiftLines();
            return;
          }

          // No gift in cart yet.
          if (qualifying >= CONFIG.thresholdCents) {
            if (!getSessionDismissed()) self.show();
          } else {
            setSessionDismissed(false);
            self.hide(false);
          }
        }).catch(function () {});
      }

      /* ---------- cart writes ---------- */

      removeLines(lines) {
        if (!lines || !lines.length) return Promise.resolve();
        var self = this;
        self.busy = true;
        var chain = Promise.resolve();
        lines.forEach(function (line) {
          chain = chain.then(function () {
            return fetch(cartMutationUrl('change.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
        });
        return chain
          .then(function () { return refreshThemeCartUI(); })
          .catch(function () {})
          .then(function () { self.busy = false; });
      }

      onAdd() {
        if (!this.selectedVariantId || this.busy) return;
        var self = this;
        var variantId = this.selectedVariantId;
        this.busy = true;
        this.setCtaLoading(true);

        fetch(cartMutationUrl('add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: buildGiftProps() }]
          })
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || 'add failed');
            return refreshThemeCartUI();
          })
          .then(function () { return self.verifyGiftFree(variantId, 0); })
          .then(function (freeOk) {
            self.busy = false;
            self.setCtaLoading(false);
            if (freeOk) {
              self.showState(CONFIG.strings.success, false);
              setTimeout(function () { self.hide(false); }, 1800);
              self.decorateGiftLines();
            } else {
              self.showState(CONFIG.strings.unavailable, true);
            }
          })
          .catch(function () {
            self.busy = false;
            self.setCtaLoading(false);
            self.showState(CONFIG.strings.unavailable, true);
          });
      }

      // Re-checks the cart (a few retries, giving the discount engine time) to
      // confirm the gift line landed at $0. If it never does, the line is pulled
      // so the shopper is never charged for it.
      verifyGiftFree(variantId, attempt) {
        var self = this;
        var delays = [600, 1000, 1500];
        return fetchCart().then(function (cart) {
          var gift = (cart.items || []).filter(isGiftItem)
            .filter(function (i) { return i.variant_id === variantId; })[0];
          if (gift && gift.final_line_price === 0) return true;
          if (!gift) return false;
          if (attempt < delays.length) {
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve(self.verifyGiftFree(variantId, attempt + 1));
              }, delays[attempt]);
            });
          }
          return self.removeLines([gift]).then(function () { return false; });
        });
      }

      /* ---------- UI ---------- */

      buildPicker() {
        if (!this.productsWrap || !this.productTpl || !this.swatchTpl) return;
        this.productsWrap.innerHTML = '';
        var self = this;

        CONFIG.products.forEach(function (product) {
          var available = (product.variants || []).filter(function (v) { return v.available; });
          if (!available.length) return;

          var node = self.productTpl.content.firstElementChild.cloneNode(true);
          node.querySelector('[data-wsg-product-title]').textContent = product.title;
          var swatchWrap = node.querySelector('[data-wsg-swatches]');

          (product.variants || []).forEach(function (variant) {
            var sw = self.swatchTpl.content.firstElementChild.cloneNode(true);
            var dot = sw.querySelector('[data-wsg-dot]');
            var label = sw.querySelector('[data-wsg-label]');
            var key = String(variant.color || '').trim().toLowerCase();
            dot.style.backgroundColor = COLOR_HEX[key] || '#cccccc';
            label.textContent = variant.color || variant.title;
            sw.setAttribute('aria-pressed', 'false');

            if (!variant.available) {
              sw.disabled = true;
              sw.title = 'Sold out';
            } else {
              sw.addEventListener('click', function () {
                self.productsWrap.querySelectorAll('[data-wsg-swatch]').forEach(function (b) {
                  b.setAttribute('aria-pressed', 'false');
                });
                sw.setAttribute('aria-pressed', 'true');
                self.selectedVariantId = variant.id;
                if (self.cta) self.cta.removeAttribute('disabled');
              });
            }
            swatchWrap.appendChild(sw);
          });

          self.productsWrap.appendChild(node);
        });
      }

      resetPicker() {
        this.selectedVariantId = null;
        if (this.cta) this.cta.setAttribute('disabled', 'disabled');
        this.setCtaLoading(false);
        this.productsWrap.querySelectorAll('[data-wsg-swatch]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        if (this.pickerView) this.pickerView.classList.remove('wsg__hidden');
        if (this.stateView) this.stateView.classList.add('wsg__hidden');
      }

      setCtaLoading(on) {
        if (!this.cta) return;
        var sp = this.cta.querySelector('.wsg__spinner');
        if (on) {
          this.cta.setAttribute('aria-disabled', 'true');
          if (!sp) {
            sp = document.createElement('span');
            sp.className = 'wsg__spinner';
            this.cta.appendChild(sp);
          }
        } else {
          this.cta.removeAttribute('aria-disabled');
          if (sp) sp.remove();
        }
      }

      showState(message, keepDismissed) {
        if (this.pickerView) this.pickerView.classList.add('wsg__hidden');
        if (this.stateView) {
          this.stateView.textContent = message;
          this.stateView.classList.remove('wsg__hidden');
        }
        if (keepDismissed) setSessionDismissed(true);
        if (!this.classList.contains('wsg--active')) this.show(true);
      }

      show(skipReset) {
        if (!skipReset) this.resetPicker();
        this.openedBy = document.activeElement && document.activeElement !== document.body
          ? document.activeElement : null;
        var self = this;
        setTimeout(function () {
          self.classList.add('wsg--active');
          if (typeof trapFocus === 'function') trapFocus(self, self.dialog);
        });
        document.body.classList.add('overflow-hidden');
      }

      hide(dismiss) {
        if (!this.classList.contains('wsg--active')) return;
        this.classList.remove('wsg--active');
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
        if (dismiss) setSessionDismissed(true);
      }

      /* ---------- cart line decoration ---------- */

      decorateGiftLines() {
        var self = this;
        fetchCart().then(function (cart) {
          var giftVariantIds = (cart.items || []).filter(isGiftItem)
            .map(function (i) { return String(i.variant_id); });

          document.querySelectorAll('.cart-item').forEach(function (row) {
            var input = row.querySelector('[data-quantity-variant-id]');
            var vid = input && input.getAttribute('data-quantity-variant-id');
            if (!vid) {
              var link = row.querySelector('a[href*="variant="]');
              if (link) {
                var m = link.getAttribute('href').match(/variant=(\d+)/);
                if (m) vid = m[1];
              }
            }
            if (vid && giftVariantIds.indexOf(String(vid)) !== -1) {
              row.classList.add('wsg-cart-line');
              if (!row.querySelector('.wsg-cart-badge')) {
                var name = row.querySelector('.cart-item__name') || row.querySelector('.cart-item__details');
                if (name) {
                  var badge = document.createElement('span');
                  badge.className = 'wsg-cart-badge';
                  badge.textContent = (CONFIG.strings && CONFIG.strings.badge) || 'Free gift';
                  name.insertAdjacentElement('afterend', badge);
                }
              }
            }
          });
        }).catch(function () {});
      }
    });
  }

  function buildGiftProps() {
    var props = {};
    props[GIFT_PROP] = 'true';
    return props;
  }
})();
